module.exports = __webpack_public_path__ + "img/circle-blue.8f2e831a.svg";